export enum NAV_ROUTE_ID {
  HOME = 'home',
  HOME_V2 = 'home_v2',
  REALTIME = 'realtime',
  ATTRIBUTION = 'attribution',
  PNL_DASHBOARD = 'pnl_dashboard',
  INCOME_STATEMENT = 'income_statement',
  META_REACH_ROLLING = 'meta_reach_rolling',
  META_REACH_COMPARISON = 'meta_reach_comparison',
  META_REACH_INCREMENTAL = 'meta_reach_incremental',
  TRAFFIC = 'traffic',
  COHORTS = 'cohorts',
  ECOMMERCE = 'ecommerce',
  KPI = 'kpi',
  ORDERS = 'orders',
  PRODUCTS = 'products',
  REPORTS_MORE = 'reports_more',
  VIEWS = 'views',
  GET_STARTED = 'get_started',
  HOME_DASHBOARD = 'home_dashboard',
  CUSTOM_DASHBOARD = 'custom_dashboard',
  ACQUISITION = 'acquisition',
  EVENTS_MANAGER = 'events_manager',
  DATA_QUALITY = 'data_quality',
  META_EMQ = 'meta_emq',
  DESTINATIONS = 'destinations',
  DATA_SOURCES = 'data_sources',
  NOTIFICATIONS = 'notifications',
  PIXEL_SETUP = 'pixel_setup',
  SHOPIFY_SETUP = 'shopify_setup',
  STRIPE_PLAN_SUCCESS = 'stripe_plan_success',
  SETTINGS_ROOT = 'settings_root',
  SETTINGS_ACCOUNT = 'settings_account',
  SETTINGS_PASSWORD = 'settings_password',
  SETTINGS_BILLING = 'settings_billing',
  SETTINGS_BILLING_V2 = 'settings_billing_v2',
  SETTINGS_USAGE = 'settings_usage',
  SETTINGS_PAYMENT_METHODS = 'settings_payment_methods',
  SETTINGS_INVOICES = 'settings_invoices',
  SETTINGS_PLANS = 'settings_plans',
  SETTINGS_API_KEYS = 'settings_api_keys',
  SETTINGS_TEAM = 'settings_team',
  SETTINGS_DASHBOARD = 'settings_dashboard',
  SETTINGS_UTM = 'settings_utm',
  SETTINGS_PIXEL = 'settings_pixel',
  SETTINGS_CUSTOM_EVENT_MAPPING = 'settings_custom_event_mapping',
  SETTINGS_NOTIFICATIONS = 'settings_notifications',
  SETTINGS_COSTS = 'settings_costs',
  ACCOUNT_BILLING_SHOPIFY = 'account_billing_shopify',
}

export enum NAV_PLACEMENT {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  SETTINGS = 'settings',
}

export enum NAV_SECTION {
  PRIMARY = 'primary',
  BOARDS = 'boards',
  CONTROL_PANEL = 'control_panel',
  NON_DASHBOARD = 'non_dashboard',
  TITLE_ONLY = 'title_only',
  SETTINGS_WORKSPACE = 'settings_workspace',
  SETTINGS_TRACKING = 'settings_tracking',
  SETTINGS_DEVELOPER = 'settings_developer',
  SETTINGS_PERSONAL = 'settings_personal',
}

export enum NAV_STATUS_KEY {
  INTEGRATION_HEALTH = 'integration_health',
  DESTINATION_HEALTH = 'destination_health',
  EVENT_HEALTH = 'event_health',
  EMQ_HEALTH = 'emq_health',
  UNREAD_NOTIFICATIONS = 'unread_notifications',
}

export enum NAV_REQUIREMENT {
  SHOPIFY_DATA = 'shopify_data',
  REALTIME_ENV = 'realtime_env',
  LEGACY_DASHBOARDS_ENV = 'legacy_dashboards_env',
  BETA_FEATURE_ENV = 'beta_feature_env',
  CONTACT_ACQUISITION_ENV = 'contact_acquisition_env',
  CONTACT_ACQUISITION_FEATURE = 'contact_acquisition_feature',
}

export enum NAV_STATUS_VARIANT {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  PENDING = 'pending',
}
